import FieldProto from "../fields3/proto/field-proto";

export interface ModelInterface {
    id      : ID
    toJSON  : {():any}
}

export default class Collection<Model extends ModelInterface> {

    public models                   : Model[]           = []
    protected byId                  : {[key:ID]:Model}  = {}
    protected onChangeBusEvent?     : string            = undefined // if set - trigger when we change something

    constructor(models: Model[] = []) {
        if (models) {
            this.reset(models)
        }
    }

    triggerBusEvent() {
        if (!this.onChangeBusEvent) return

        gd.bus.triggerEvent(this.onChangeBusEvent)
    }

    // old used in gd.sessionCustomViews ?
    get all() {
        return this.models
    }

    get items() {
        return this.models
    }

    get isEmpty() {
        return !this.models || this.models.length < 1
    }

    get length() {
        return this.models ? this.models.length : 0
    }

    get ids() {
        return _.keys(this.byId)
    }

    reset(models?:Model[]) {
        this.models    = []
        this.byId      = {}

        _.map(models, model=>{
            this.add(model)
        })

        this.triggerBusEvent()
    }

    add(model:Model | null) {

        // this helps dealing with factory which return null...
        if (!model) return

        // vozmozno eto horosho i dolzno bit' tut - a vozmono net... hez :) poka mi tak delaem tol'ko v ItemsCollection
        // const existingModel = this.byId[model.id]
        // if (existingModel) {
        //     console.log("#8474uu Collection Model", model.id, "already existis -> Skip")
        //     return
        // }

        this.models.push(model)
        this.byId[model.id] = model

        this.triggerBusEvent()
    }

    addAtPosition(model:Model, position:number) {
        this.models.splice(position, 0, model)
        this.byId[model.id] = model
    }

    remove(id:ID) {
        delete this.byId[id]

        const result = _.remove(this.models, model=>model.id === id)

        this.triggerBusEvent()

        return result
    }

    replace(id: ID, model:Model) {
        // find index of model to replace
        const index = _.findIndex(this.models, model=>model.id === id)

        // replace model at index
        this.models.splice(index, 1, model)

        delete this.byId[id]        // remove old model
        this.byId[model.id] = model // add new model

        this.triggerBusEvent() // do we need it here ?
    }

    get(id: ID):Model | null {
        return this.byId[id]
    }

    // Delta - CANT DO IT HERE  !!! becaue we dont' know modela etc.
    // add this method in child class
    // applyDelta(method:string, data:any) {
    //
    //     switch (method) {
    //         case 'delete':
    //             this.remove(data.id);
    //             break
    //
    //         case 'new':
    //             this.add(this.createModel(data, this.options));
    //             break;
    //
    //         case 'delta':
    //             const model = this.get(data.id);
    //             if (model) model.applyDelta(data);
    //             break;
    //     }
    // }

    // used when we want to store sort position within collection itself
    // i.e. manual sorting without sortPosition field
    reorderByIds(orderedIds: ID[]):void {
        const result:any[] = []
        _.map(orderedIds, id=>{
            result.push(this.get(id))
        })
        this.models = result
    }

    toJSON():any {
        return _.map(this.models, (model)=>{
            return model.toJSON()
        })
    }

    exportToCSV(arrayOfFields:FieldProto[], arrayOfIds:fieldId[], fileName: string = 'file-name') {
        throw Error("Not implemented #kdjsi")
    }
}
